import * as angular from "angular";
import {IController} from "angular";
import {LocationType} from "../../types/location.type";

export class BringozLocationSelectCtrl implements IController {

  locationType: LocationType;
  locationId: string;
  excludeIds: string[];
  accountIds: string[];
  branchIds: string[];
  allowGlobalCustomers: boolean;
  depotOptionIds: string[];
  isRequired?: boolean;
  enableDisplayAllCustomers?: boolean;
  isHideCustomAddress: boolean;
  onLocationTypeChange: Function;
  onAccountSelect: Function;
  onDepotSelect: Function;
  onCustomerSelect: Function;

  public locationTypes: typeof LocationType = LocationType;
  public enabledOptions: any;

  constructor(private planningConstants) {
    this.locationTypes = LocationType;
  }

}


angular
  .module('bringoz.admin.commons')
  .component('bringozLocationSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      locationType: '<',
      locationId: '<',
      excludeIds: '<?',
      accountIds: '<?',
      branchIds: '<?',
      allowGlobalCustomers: '<?',
      depotOptionIds: '<?',
      isRequired: '<?',
      enableDisplayAllCustomers: '<?',
      isHideCustomAddress: '<?',
      onLocationTypeChange: '&',
      onAccountSelect: '&',
      onDepotSelect: '&',
      onCustomerSelect: '&'
    },
    template: require('./bringoz-location-select.html').default,
    controller: BringozLocationSelectCtrl
  });
